const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const API_BASE_URL = `${SUPABASE_URL}/functions/v1`;
import { supabase } from './supabase';

export async function inviteUser(data: { 
  email: string; 
  name: string; 
  role: 'app.viewer' | 'app.manager' 
}) {
  try {
    console.log('Inviting user:', data);
    
    const response = await fetch(`${API_BASE_URL}/invite-user`, {
      method: 'POST',
      headers: {
        'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${(await supabase.auth.getSession()).data.session?.access_token || ''}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Failed to parse error response' }));
      console.error('Invite user API error:', errorData);
      throw new Error(
        errorData.error || 
        `Failed to invite user (${response.status})`
      );
    }

    return await response.json();
  } catch (error: unknown) {
    console.error('Invite user error:', error);
    throw error instanceof Error 
      ? error 
      : new Error('An unexpected error occurred while inviting user');
  }
}

export async function sendInvitationEmail(data: { 
  email: string; 
  password: string; 
  name: string 
}) {
  try { 
    const response = await fetch(`${API_BASE_URL}/invitation-email`, {
      method: 'POST',
      headers: {
        'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || 
        `Failed to send invitation email (${response.status})`
      );
    }

    return await response.json();
  } catch (error: unknown) {
    console.error('Send invitation email error:', error);
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('Failed to send invitation email');
  }
}

export async function sendIssueNotification(issueId: string, recipientIds: string[]) {
  try {
    // Get the current session
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session?.access_token) {
      throw new Error('No active session');
    }

    const response = await fetch(`${API_BASE_URL}/send-notification`, {
      method: 'POST',
      headers: {
        'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
        'Authorization': `Bearer ${session.access_token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        issueId,
        recipientIds
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || 
        `Failed to send notification (${response.status})`
      );
    }

    return await response.json();
  } catch (error) {
    console.error('Notification error:', error);
    throw error instanceof Error ? error : new Error('Unknown error occurred');
  }
}